export const CONSULTATION_URL =
  "https://calendly.com/d/cxy2-dy2-tqk/mutetaxes-consultation-call";
export const SPECIALIST_URL =
  "https://api.whatsapp.com/send?phone=447878491102&text=Hi%20MuteTaxes%20team!";

/**
 * Rotated by `openWhatsAppWithUtm` (see lib/whatsapp.ts). Each visitor is
 * assigned one number randomly on first click; that assignment sticks in
 * localStorage so the same browser always reaches the same agent.
 */
export const WA_NUMBERS = ["447878491102"];
